import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_54: FaireProductEntity = {
  token: "catalog_prod_prod-54",
  type: "product",
  name: "Wool Throw Blanket - Herringbone",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 76.63,
  msrpDollars: 191.58,
  sku: "JA0054",
  caseSize: 2,
  material: "Linen",
  collectionToken: "col_japandi",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 153,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_stickers-pins"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
